// extracted by mini-css-extract-plugin
export default {"overlay":"PageOverlay_overlay__Q80d6","dark":"PageOverlay_dark__B1P6M"};